import React, { useEffect, useState, useRef } from 'react'
import Logo from '../../Assets/Images/logo.svg'
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { styled } from '@mui/material/styles';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { format, parseISO } from 'date-fns';
import Loading from '../../Components/Input/Loading';
import getServices from '../../Services/get-service';
import Constant from '../../Constant';
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { getBranding } from '../../utils/getBranding';
const StyledTableCell = styled(TableCell)(({ theme }) => ({

  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'var(--color-primary)',
    color: 'white',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const Index = () => {
  const [transaction, setTransaction] = useState([])
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false)
  const [rowsPerPage, setRowsPerPage] = useState(10);
   const [filterValue, setFilterValue] = useState('all')
   const receiptRef = useRef(null);
   const branding = getBranding();
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() =>{
    setLoading(true)
    getServices.getTransactionHistory().then(
        (response) => {
          
          setTransaction(response.data.data.reverse());
          console.log(response.data.data)
          setLoading(false)
        },
        (error) => {
          
        }
      )
}, [])

const downloadReceipt = async (tran) => {
  const pdf = new jsPDF("p", "mm", "a4");
  const imgWidth = 40;
  const imgHeight = 20;
  const xCenter = (210 - imgWidth) / 2; // Center horizontally

  // Convert Logo (SVG or PNG) to Base64
  const getBase64Image = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.src = url;
      img.onload = function () {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = (error) => reject(error);
    });
  };

  try {
    const logoBase64 = await getBase64Image(Logo);
    pdf.addImage(logoBase64, "PNG", xCenter, 10, imgWidth, imgHeight);
  } catch (error) {
    console.error("Error loading logo:", error);
  }

  pdf.setFontSize(18);
  pdf.text("Transaction Receipt", 70, 40);

  pdf.setFontSize(12);
  pdf.text(`Transaction Type: ${tran.transType === 'D' ? 'Debit' : 'Credit'}`, 10, 60);
  pdf.text(`Amount: NGN ${tran.amount}`, 10, 70);
  pdf.text(`Date: ${format(parseISO(tran.createdDate), 'MMM d yyyy hh:mm:ss a')}`, 10, 80);
  pdf.text(`Status: ${tran.status ?? 'N/A'}`, 10, 90);
  pdf.text(`Narration: ${tran.narration ?? 'N/A'}`, 10, 100);
  pdf.text(`Provider Reference: ${tran.providerReference ?? 'N/A'}`, 10, 110);

  pdf.save(`Receipt_${tran.createdDate}.pdf`);
};


let filteredData =  filterValue === 'all'?
transaction
:
transaction.filter(item => item.transType  === filterValue);

  return (
    <div>
     <Loading
      open={loading}
    />
      <h1 className=' font-bold'>Transaction</h1>
     <div className=' mb-6 mt-2 grid grid-cols-3 gap-3'>
       <div>
       <p className=' mb-2'>Filter by Transaction type:</p>
        <select value={filterValue} 
        onChange={(e) =>setFilterValue(e.target.value)}
        className=' w-full p-3 border rounded-lg'>
         <option  value={'all'}>All</option>
          <option  value={'D'}>Debit</option>
          <option value={'C'}>Credit</option>
        </select>
       </div>
     </div>
    <Paper className=' ' sx={{ width: '100%', overflow: 'hidden' }}>
      <TableContainer sx={{ maxHeight: 600 }}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead style={{backgroundColor:'red', color: 'white',}}>
            <TableRow >
            <StyledTableCell>Transaction type</StyledTableCell>
            <StyledTableCell align="left">Date/Time</StyledTableCell>
            <StyledTableCell align="left">Amount</StyledTableCell>
            <StyledTableCell align="left">Status</StyledTableCell>
            <StyledTableCell align="left">Download</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((tran) => (
                
            <TableRow
              key={tran.transactionDate}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
             <span className=' capitalize'>{tran.transType === 'D'?<span className=' text-custom-red'>Debit</span> :<span className=' text-custom-green'>Credit</span>}</span> 
              </TableCell>
              <TableCell align="left">{format(parseISO(tran.createdDate), 'MMM d yyyy hh:mm:ss a')}</TableCell>
              <TableCell align="left"> {tran.transType === 'D' ?<span className='text-custom-red'>- NGN {tran.amount}</span>:<span className='text-custom-green'>+ NGN {Constant.FormatNumber(tran.amount??0.0) }</span>}</TableCell>
              {/* <TableCell align="left">{tran.narration}</TableCell> */}
              <TableCell align="left">{tran.narration !== null ? tran.narration?.slice(0,45):tran.narration} </TableCell>
               <TableCell align="left" onClick={() => downloadReceipt(tran)}><span className=' cursor-pointer p-3 rounded-md text-white ' style={{ backgroundColor: branding.color.primary }}>Download</span> </TableCell>
            </TableRow>
          ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      {filteredData.length === 0 && <p className=' text-center font-bold text-red-700 mt-5'>No transaction</p>}
    </Paper>
    </div>
  )
}

export default Index





const Receipt = () => {
  const receiptRef = useRef(null);

  const downloadReceipt = () => {
    const input = receiptRef.current;

    html2canvas(input, { scale: 3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const imgWidth = 180; // Adjust width to center properly
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      const xPos = (210 - imgWidth) / 2; // Center horizontally
      const yPos = 20; // Start lower to accommodate the logo

      pdf.addImage(imgData, "PNG", xPos, yPos, imgWidth, imgHeight);
      pdf.save("receipt.pdf");
    });
  };


  return (
    <div className="receipt-container">
      <div className="receipt" ref={receiptRef}>
        <div className="header">
          <img src={Logo} alt="Moniepoint" className="logo" />
          <h2>DEBIT</h2>
          <h1>₦15,500.00</h1>
        </div>

        <div className="details">
          <p><strong>Transaction Type:</strong> TRANSFER</p>
          <p><strong>Beneficiary:</strong> ABIODUN RUKAYAT OLANREWAJU | 8145397911</p>
          <p><strong>Beneficiary Institution:</strong> PalmPay</p>
          <p><strong>Sender Name:</strong> DAVID INIOLUWA AJIBADE</p>
          <p><strong>Source Institution:</strong> MONIEPOINT</p>
          <p><strong>Transaction Date:</strong> Sunday, March 2nd, 2025 | 8:53 PM</p>
          <p><strong>Narration:</strong> for hair</p>
          <p><strong>Provider Reference:</strong> 0904052503022053594351344512PP</p>
        </div>
      </div>

     
    </div>
  );
};

export { Receipt };
